'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import type { DateStreakWeekProps } from '../DateStreak.types';
import { DateStreakDay } from './DateStreakDay';

import styles from './DateStreakWeek.module.scss';

function DateStreakWeek({
  style,
  className,
  items,
  testId = 'ui-date-streak-week',
}: BaseComponentProps & DateStreakWeekProps) {
  return (
    <div
      className={classnames(styles['date-streak-week'], className)}
      style={style}
      data-testid={testId}
    >
      {items.map((item, index) => (
        <DateStreakDay key={index} {...item} />
      ))}
    </div>
  );
}

export { DateStreakWeek };
